import FizyLogo from './fizy-logo.component';

export default angular
  .module('fizyweb.paycell.fizylogo', [])
  .component('fizyLogo', FizyLogo).name;



// WEBPACK FOOTER //
// src/app/components/fizy-logo/fizy-logo.module.ts